import {
  SET_UPGRADE_REQUESTED,
  SET_UPGRADE_REQUESTED_FETCHING,
} from 'constants/actions';

const DEFAULT_UPGRADE_STATE = {
  requestStatus: null,
  fetching: false,
  fetched: false,
};

const upgradeState = (state = DEFAULT_UPGRADE_STATE, action) => {
  switch (action.type) {
    case SET_UPGRADE_REQUESTED:
      return {
        ...state,
        requestStatus: action.requestStatus,
      };

    case SET_UPGRADE_REQUESTED_FETCHING:
      return {
        ...state,
        fetching: action.fetching,
        fetched: state.fetched || (state.fetching && !action.fetching),
      };

    default:
      return state;
  }
};

export default upgradeState;
